/**
 * 区域管理API
 */
import http from '../http';
import {
  AddRegionData,
  AddRegionResponse,
  CheckDuplicateResponse,
  DeleteOrMoveResponse,
  FullRegionListResponse,
  GetAreaListData,
  GetCheckNameData,
  MoveAreaData,
  RegionGroupItem,
  RegionListResponse,
} from './data.d';

// 接口前缀
const MODEL = '/region_group';

export default {
  // 区域名查重
  getCheckName(data: GetCheckNameData): Promise<CheckDuplicateResponse> {
    return http.post(`${MODEL}/check_name`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取区域的地区列表
  getAreaList(data: GetAreaListData = {}): Promise<RegionListResponse> {
    return http.post(`${MODEL}/get_country`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  // 获取所有区域列表
  getFullRegionList(
    data: GetAreaListData = {},
  ): Promise<FullRegionListResponse> {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  // 创建或修改自定义区域
  createUpdateArea(data: RegionGroupItem): Promise<AddRegionResponse> {
    return http.post(`${MODEL}/add`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  // 删除自定义区域
  deleteArea(data: AddRegionData): Promise<DeleteOrMoveResponse> {
    return http.post(`${MODEL}/delete`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  // 移动区域
  moveRegions(data: MoveAreaData): Promise<DeleteOrMoveResponse> {
    return http.post(`${MODEL}/move`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
